// utils.js
export function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
}
export function loadScriptsSequentially(scripts) {
    return scripts.reduce((promise, script) => {
        return promise.then(() => loadScript(script));
    }, Promise.resolve());
}

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}
